import { useCallback, useState } from "react";
import useAxiosPrivate from "../../../hooks/server/useAxiosPrivate";
import useSetTokenState from "./useSetTokenState";

import { useDispatch } from "react-redux";
import { uiStateActions } from "../../../store/ui-state";

function useUserLogout() {
  const axiosPrivate = useAxiosPrivate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const setToken = useSetTokenState();

  const requestLogout = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axiosPrivate.get("/api/auth/logout");

      dispatch(uiStateActions.logout());
      setToken(null);
      console.log(response);
    } catch (error) {
      console.log(error.response);
    } finally {
      setLoading(false);
    }
  });

  return [requestLogout, loading, error];
}

export default useUserLogout;
